import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Maritime Supply Suite - Secure Node Guard
 * Ensures only authorized System Dispatchers can access administrative routes with valid tenant scopes.
 */
export default function AdminProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  // Wait for session synchronization
  if (loading) return null;

  // Verify active session
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Verify dispatcher privileges
  if (user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  // Verify tenant context consistency
  const adminSession = JSON.parse(localStorage.getItem("adminUser") || "{}");
  const activeTenantId = adminSession.adminId || localStorage.getItem("adminId");

  if (!activeTenantId && !user.adminId) {
    // Force re-authentication if tenant boundary is missing
    return <Navigate to="/login" replace />;
  }

  return children;
}